/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('@fortawesome/fontawesome-free/js/all');
require('./timetranslate');

import './utils/utilities';
import './utils/dom/dom';
import './utils/ui/ui';
import './utils/math/math';
import './utils/charts';
import './utils/layout/layoutHelpers';
import './utils/datatables';
import './feedback/confirm/confirm-manager';

import Vue from 'vue'; // TODO: remove when all vue.js is removed
import 'livewire-vue'; // TODO: remove when all livewire-vue is removed

window.Vue = Vue; // TODO: remove when all vue.js is removed

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// TODO: remove when all vue.js is removed
const app = new Vue({
    el: '#app',
});
